import { local, session } from 'store2'

class RedirectService {
    initialize(redirectTo, bloques) {
        if (!local.has('redirect_to') && redirectTo) {
            local.set('redirect_to', redirectTo, true)
        }
        if (!session.has('bloques') && bloques) {
            session.set('bloques', bloques, true)
        }
    }

    get redirectTo(): string {
        return local.get('redirect_to')
    }

    get bloques(): string {
        return session.get('bloques')
    }

    clear() {
        if(local.has('redirect_to')) {
            local.remove('redirect_to')
        }
        if(session.has('bloques')) {
            session.remove('bloques')
        }
    }
}

export default RedirectService
export const redirect = new RedirectService()
